import { client } from "../client/client";

export const createBorrower = async (
  altPhoneNumber,
  email,
  mobileno,
  maritalStatus,
  dependants,
  username,
  postal_address,
) => {
  try {
    // Build initial payload
    let payload = {
      altPhoneNumber,
      email,
      mobileno,
      maritalStatus,
      dependants: dependants !== "" ? Number(dependants) : undefined,
      username,
      postal_address,
    };

    // Remove null, undefined, and empty string fields
    payload = Object.fromEntries(
      Object.entries(payload).filter(
        ([, value]) =>
          value !== null &&
          value !== undefined &&
          value !== "" &&
          !(typeof value === "string" && value.trim() === ""),
      ),
    );

    const response = await client.post("/customer", payload);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const updateBorrower = async (
  customerId,
  firstname,
  middlename,
  lastname,
  identification,
  identification_type,
  country_of_residence,
  dob,
  citizenship,
  gender,
  id_back_image,
  id_front_image,
  postal_address,
) => {
  try {
    const response = await client.patch(`/customer/${customerId}`, {
      id: customerId,
      firstname,
      middlename,
      lastname,
      identification,
      identification_type,
      country_of_residence,
      dob,
      citizenship,
      gender,
      id_back_image,
      id_front_image,
      onboarding_stage: "id_details",
      postal_address,
    });
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
export const updateMyBorrower = async (
  customerId,
  firstname,
  middlename,
  lastname,
  identification,
  identification_type,
  country_of_residence,
  dob,
  citizenship,
  gender,
  postal_address,
  altPhoneNumber,
  email,
  dependants,
  mobileno,
  username,
) => {
  try {
    const response = await client.patch(`/customer/${customerId}`, {
      id: customerId,
      firstname,
      middlename,
      lastname,
      identification,
      identification_type,
      country_of_residence,
      dob,
      citizenship,
      gender,
      postal_address,
      altPhoneNumber,
      email,
      dependants,
      mobileno,
      username,
    });
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const updateMyBorrowerInfo = async (
  customerId,
  firstname,
  middlename,
  lastname,
  identification,
  identification_type,
  country_of_residence,
  dob,
  citizenship,
  gender,
  postal_address,
  altPhoneNumber,
  email,
  dependants,
  mobileno,
  username,
  id_front_image,
  selfie_image,
) => {
  try {
    const response = await client.patch(`/customer/${customerId}`, {
      id: customerId,
      firstname,
      middlename,
      lastname,
      identification,
      identification_type,
      country_of_residence,
      dob,
      citizenship,
      gender,
      postal_address,
      altPhoneNumber,
      email,
      dependants,
      mobileno,
      username,
      id_front_image,
      selfie_image,
    });
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addNextOfKin = async (
  customerId,
  name,
  dateOfBirth,
  relationship,
  phoneNumber,
  location,
) => {
  try {
    const response = await client.post(`/customer/${customerId}/next-of-kin`, {
      name,
      relationship,
      phoneNumber,
      location,
    });
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addIncomeDetails = async (
  customerId,
  sourceOfIncome,
  yearsOfOperation,
  typeOfBusiness,
  businessOwnership,
  levelOfStability,
  risksAssociated,
  strengthOfBusiness,
  businessLicense,
  employerName,
  monthlyIncome,
  durationAtEmployer,
  businessKraPin,
  businessName,
) => {
  try {
    const response = await client.post(`/customer/${customerId}/income`, {
      sourceOfIncome,
      yearsOfOperation,
      typeOfBusiness,
      businessOwnership,
      levelOfStability,
      risksAssociated,
      strengthOfBusiness,
      businessLicense,
      employerName,
      monthlyIncome,
      durationAtEmployer,
      businessKraPin,
      businessName,
    });
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const updateBorrowerIncomeDetails = async (
  customerId,
  sourceOfIncome,
  yearsOfOperation,
  typeOfBusiness,
  businessOwnership,
  levelOfStability,
  risksAssociated,
  strengthOfBusiness,
  businessLicense,
  employerName,
  monthlyIncome,
  durationAtEmployer,
  businessKraPin,
  businessName,
) => {
  const fullPayload = {
    sourceOfIncome,
    yearsOfOperation,
    typeOfBusiness,
    businessOwnership,
    levelOfStability,
    risksAssociated,
    strengthOfBusiness,
    businessLicense,
    employerName,
    monthlyIncome,
    durationAtEmployer,
    businessKraPin,
    businessName,
  };
  const filteredPayload = Object.fromEntries(
    Object.entries(fullPayload).filter(
      ([_, value]) => value !== null && value !== undefined && value !== "",
    ),
  );

  try {
    const response = await client.put(
      `/customer/${customerId}/income`,
      filteredPayload,
    );
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addBankStatement = async (
  customerId,
  bankName,
  bankStatementUrl,
  bankStatementCode,
  bankStatementPeriod,
) => {
  try {
    const response = await client.put(`/customer/${customerId}/income`, {
      bankStatementCode,
      bankName,
      bankStatementUrl,
      bankStatementPeriod,
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addMpesaStatement = async (
  customerId,
  mpesaCode,
  mpesaStatementUrl,
) => {
  try {
    const response = await client.put(`/customer/${customerId}/income`, {
      mpesaCode,
      mpesaStatementUrl,
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addPayslips = async (customerId, payslips) => {
  try {
    const response = await client.put(`/customer/${customerId}/income`, {
      payslips: payslips,
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const updateBorrowerBusinessDetails = async (
  customerId,
  businessName,
  businessCounty,
  businessSubCounty,
  businessWard,
  businessVillage,
  businessLatitude,
  businessLongitude,
  businessPhysicalAddress,
  businessLocationDescription,
  businessImageUrl,
  businessPostalAddress,
) => {
  try {
    const response = await client.post(`/customer/${customerId}/business`, {
      businessName,
      businessCounty,
      businessSubCounty,
      businessWard,
      businessVillage,
      businessLatitude,
      businessLongitude,
      businessPhysicalAddress,
      businessLocationDescription,
      businessImageUrl,
      businessPostalAddress,
    });
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const editMyBorrowerBusinessDetails = async (
  customerId,
  businessName,
  businessLatitude,
  businessLongitude,
  businessPhysicalAddress,
  businessLocationDescription,
  businessImageUrl,
  businessPostalAddress,
) => {
  try {
    const payload = {
      businessName,
      businessLatitude,
      businessLongitude,
      businessPhysicalAddress,
      businessLocationDescription,
      businessImageUrl,
      businessPostalAddress,
    };
    console.log(payload);
    Object.keys(payload).forEach((key) => {
      if (
        payload[key] === null ||
        payload[key] === undefined ||
        (typeof payload[key] === "string" && payload[key].trim() === "")
      ) {
        delete payload[key];
      }
    });

    const response = await client.put(
      `/customer/${customerId}/business`,
      payload,
    );
    return response.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const updateBorrowerResidenceDetails = async (
  customerId,
  residenceCounty,
  residenceSubCounty,
  residenceWard,
  residenceVillage,
  residenceLatitude,
  residenceLongitude,
  residencePhysicalAddress,
  residenceLocationDescription,
  residenceImageUrl,
) => {
  try {
    const response = await client.post(`/customer/${customerId}/residence`, {
      customerId,
      residenceCounty,
      residenceSubCounty,
      residenceWard,
      residenceVillage,
      residenceLatitude,
      residenceLongitude,
      residencePhysicalAddress,
      residenceLocationDescription,
      residenceImageUrl,
    });
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const patchBorrowerResidenceDetails = async (
  customerId,
  residenceLatitude,
  residenceLongitude,
  residencePhysicalAddress,
  residenceLocationDescription,
  residenceImageUrl,
) => {
  try {
    const payload = {
      customerId,
      residenceLatitude,
      residenceLongitude,
      residencePhysicalAddress,
      residenceLocationDescription,
      residenceImageUrl,
    };
    Object.keys(payload).forEach((key) => {
      if (
        payload[key] === null ||
        payload[key] === undefined ||
        (typeof payload[key] === "string" && payload[key].trim() === "")
      ) {
        delete payload[key];
      }
    });

    const response = await client.put(
      `/customer/${customerId}/residence`,
      payload,
    );
    return response.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addBorrowerChattel = async (
  customerId,
  name,
  location,
  value,
  fileUrl,
  description,
  condition,
  images,
) => {
  try {
    const response = await client.post(`/customer/upload-chattel`, {
      customerId,
      name,
      location,
      value,
      fileUrl,
      description,
      condition,
      images,
    });
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const editMyBorrowerChattel = async (
  chattelId,
  name,
  location,
  value,
  fileUrl,
  description,
  condition,
  images,
) => {
  try {
    const response = await client.patch(`/customer/chattels/${chattelId}`, {
      name,
      location,
      value,
      fileUrl,
      description,
      condition,
      images,
    });
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getBorrowerChattels = async (customerId) => {
  try {
    const response = await client.get(`/customer/${customerId}/chattels`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const deleteBorrowerChattel = async (id) => {
  try {
    const response = await client.delete(`/customer/chattels/${id}`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getAllBorrowers = async (
  page,
  limit,
  fromDate,
  toDate,
  search,
  status,
) => {
  try {
    const params = new URLSearchParams();

    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (search) params.append("q", search);
    if (status) params.append("status", status);
    const response = await client.get(`/customer?${params.toString()}`);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const borrowersTotals = async () => {
  try {
    const response = await client.get(`/loans/borrower-stats`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const editBorrowerPersonalDetails = async (
  id,
  firstname,
  middlename,
  lastname,
  identification,
  dob,
  gender,
  mobileno,
  altPhoneNumber,
  dependants,
  maritalStatus,
  email,
  postal_address,
) => {
  try {
    const allFields = {
      firstname,
      middlename,
      lastname,
      identification,
      dob,
      gender,
      mobileno,
      altPhoneNumber,
      dependants,
      maritalStatus,
      email,
      postal_address,
    };

    // Filter out fields that are undefined, null or empty string
    const filteredPayload = Object.fromEntries(
      Object.entries(allFields).filter(
        ([_, value]) => value !== undefined && value !== null && value !== "",
      ),
    );

    const response = await client.patch(`/customer/${id}`, filteredPayload);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const editNextOfKinDetails = async (
  kinId,
  name,
  dateOfBirth,
  relationship,
  phoneNumber,
  location,
) => {
  try {
    const allFields = {
      name,
      dateOfBirth,
      relationship,
      phoneNumber,
      location,
    };

    // Remove undefined, null, or empty string values
    const filteredPayload = Object.fromEntries(
      Object.entries(allFields).filter(
        ([_, value]) => value !== undefined && value !== null && value !== "",
      ),
    );

    const response = await client.patch(
      `/customer/next-of-kin/${kinId}`,
      filteredPayload,
    );
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const editIncomeDetails = async (
  id,
  sourceOfIncome,
  yearsOfOperation,
  typeOfBusiness,
  businessOwnership,
  levelOfStability,
  risksAssociated,
  strengthOfBusiness,
  businessLicense,
  employerName,
  monthlyIncome,
  durationAtEmployer,
  businessKraPin,
  businessName,
) => {
  try {
    const allFields = {
      sourceOfIncome,
      yearsOfOperation,
      typeOfBusiness,
      businessOwnership,
      levelOfStability,
      risksAssociated,
      strengthOfBusiness,
      businessLicense,
      employerName,
      monthlyIncome,
      durationAtEmployer,
      businessKraPin,
      businessName,
    };

    // Filter out undefined, null, or empty string values
    const filteredPayload = Object.fromEntries(
      Object.entries(allFields).filter(
        ([_, value]) => value !== undefined && value !== null && value !== "",
      ),
    );

    const response = await client.put(
      `/customer/${id}/income`,
      filteredPayload,
    );
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getBorrowerById = async (id) => {
  try {
    const response = await client.get(`/customer/${id}`);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addChattelImage = async (chattelId, urls) => {
  try {
    const response = await client.post(
      `/customer/chattels/${chattelId}/images`,
      {
        urls: urls,
      },
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const deleteChattelImage = async (chattelId, imageId) => {
  try {
    const response = await client.delete(
      `/customer/chattels/${chattelId}/images/${imageId}`,
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export async function uploadBorrowerSelfie(file, borrowerId) {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await client.post(
      `/customer/upload-selfie/${borrowerId}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
}
